// Provider video IDs are opaque. Season/episode numbers are only for finding metadata.
const findEpisode = (videos, season, episode) => {
    if (!Array.isArray(videos) || !Number.isInteger(Number(season)) || !Number.isInteger(Number(episode))) return null;
    return videos.find((video) => video.season === Number(season) && video.episode === Number(episode) &&
        typeof video.id === 'string' && video.id.trim().length > 0) || null;
};

module.exports = findEpisode;
